import { render } from "./VUEPopupTensioneAssorbimento.vue?vue&type=template&id=b659d520"
import script from "./VUEPopupTensioneAssorbimento.vue?vue&type=script&lang=js"
export * from "./VUEPopupTensioneAssorbimento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__